import { render } from "./ChangesdvVerification.vue?vue&type=template&id=6dad80b4&scoped=true"
import script from "./ChangesdvVerification.js?vue&type=script&lang=js"
export * from "./ChangesdvVerification.js?vue&type=script&lang=js"

import "./ChangesdvVerification.vue?vue&type=style&index=0&id=6dad80b4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dad80b4"]])

export default __exports__